import * as pathToRegexp from 'path-to-regexp'
import * as React from 'react'
import { connect } from 'react-redux'
import { Redirect } from 'react-router'
import { Link } from 'react-router-dom'
import { getEntry, getEntryUrl } from '../data/entries/entry'
import { EntryKey } from '../data/entries/types'
import { SiteCountry } from '../data/models/locale'
import { AppState } from '../data/state'
import { store } from '../store/store'
import { urls } from '../urls'
import { createQueryString } from '../utils/urls'
import { getCountryRegex } from './country_routes'

/** Get URL by name */
export function getLink(
  country: string,
  name: string,
  params: { [key: string]: string } = {},
): string {
  const grp = urls[name] || { urls: {} }
  let url = grp.urls[country] || grp.urls[`default`] || ''
  const queryParams: any = {}

  if (params) {
    for (const param in params) {
      if (params.hasOwnProperty(param) && params[param] !== undefined) {
        if (url.indexOf(`:${param}`) !== -1) {
          url = url.replace(`:${param}`, params[param])
        } else if (param !== 'country_code') {
          queryParams[param] = params[param]
        }
      }
    }
    if (Object.keys(queryParams).length > 0) {
      url += `?${createQueryString(queryParams)}`
    }
  }
  const optionsParamRegex = /\/:\w+(\([\w-|]+\))?\?/g
  if (url.search(optionsParamRegex)) {
    // remove optional parameters
    url = url.replace(optionsParamRegex, '')
  }
  return `/${country}${url === '/' ? '' : url}`
}

export function getLinkFromName(
  name: string,
  params: { [key: string]: string } = {},
): string {
  const newState: AppState = store.getState()
  return getLink(newState.locale.country, name, params)
}

export function getNameWithTheme(name: string): string {
  const newState: AppState = store.getState()
  if (newState.funnelOrder.entry !== EntryKey.none) {
    return `entry${name}`
  }
  return (newState.funnelOrder.theme.toString() + name).replace('-', '')
}

export function getParamsWithTheme(): any {
  const newState: AppState = store.getState()
  if (newState.funnelOrder.entry !== EntryKey.none) {
    const entry = getEntry(newState.funnelOrder.entry)
    if (entry && entry.page) {
      return { code: getEntryUrl(entry.page) }
    }
  }
  return undefined
}

/** Extract URL name from a path */
export function getLinkName(path: string): string {
  for (const name in urls) {
    if (urls.hasOwnProperty(name)) {
      for (const [country, url] of Object.entries(urls[name].urls)) {
        const regex = pathToRegexp(url)
        const prefix = getCountryRegex(country)
        const match = path.match(prefix)
        const pathNoCountryCode =
          path.search(prefix) !== -1
            ? match !== null
              ? path.substr(match[0].length)
              : path.substr(3)
            : path.substr(3)

        if (pathNoCountryCode.match(regex) !== null) {
          return name
        }
      }
    }
  }
  return ''
}

/** A component to create redirects by name */
interface LinkProps {
  name: string
  params?: any
  country?: SiteCountry
  stateCountry: SiteCountry
  className?: string
  openInNewTab?: boolean
  children?: React.ReactNode | undefined
}

const SrprsLink: React.FC<LinkProps> = ({
  name,
  params,
  stateCountry,
  country,
  children,
  openInNewTab,
  className,
}) => {
  const route = getLink(country || stateCountry, name, params)
  const extraAttributes = openInNewTab
    ? {
        target: '_blank',
        onClick: (event: React.MouseEvent<HTMLAnchorElement>) => {
          event.preventDefault()
          window.open(route)
        },
      }
    : {}
  return (
    <Link className={className} to={route} {...extraAttributes}>
      {children}
    </Link>
  )
}

const mapStateToProps = (state: AppState) => ({
  stateCountry: state.locale.country,
})

export const Slink = connect(mapStateToProps)(SrprsLink)

interface RedirProps {
  name: string
  params?: any
  country?: SiteCountry
  stateCountry: SiteCountry
  push?: boolean
}

const SrprsRedirect: React.FC<RedirProps> = ({
  name,
  country,
  stateCountry,
  params,
  push,
}) => {
  return (
    <Redirect to={getLink(country || stateCountry, name, params)} push={push} />
  )
}

export const Sredirect = connect((state: AppState) => ({
  stateCountry: state.locale.country,
}))(SrprsRedirect)
